import { useMutation } from "@apollo/client";
import Button from "components/base/Button";
import { Alert } from "components/base/Toast";
import { ProductImagesV2 } from "components/shared/ProductImages";
import { useNavigate } from "react-router-dom";
import { CREATE_PO_REPORT } from "./graphql";

const CreatePoReport = ({
  product,
  qty,
  poOdooId,
  poLineOdooId,
  po,
  onCreated,
}) => {
  const navigate = useNavigate();
  const [createReport, createReportRes] = useMutation(CREATE_PO_REPORT, {
    onCompleted: (res) => {
      Alert("success", "PO QC Report 创建成功！");
      if (onCreated) onCreated();
      navigate(`/qc/po-reports/${res.createPoReport.poReport.id}`);
    },
    onError: (error) => Alert("error", error.message),
    refetchQueries: ["FETCH_QC_REPORTS_LIST"],
  });

  const images = product.computedImages;

  return (
    <div className="space-y-6 text-base">
      <div>
        <div className="flex flex-wrap">
          <ProductImagesV2 images={images} />
        </div>
        <div className="mt-3">
          {product.name}
          <span className="ml-3 font-bold"> &times; {qty}</span>
        </div>
      </div>

      <div className="flex items-center space-x-3">
        <label>Supplier:</label>
        <div className="font-bold">
          {product?.defaultSupplier?.name || "N/A"}
        </div>
      </div>

      <Button
        next
        loading={createReportRes.loading}
        onClick={() =>
          createReport({
            variables: {
              productId: product.id,
              qty,
              poOdooId,
              poLineOdooId: poLineOdooId || null,
              po,
            },
          })
        }
      >
        Next 下一步
      </Button>
    </div>
  );
};

export default CreatePoReport;
